// extracted by mini-css-extract-plugin
export var cell = "_6f-4";
export var headerCell = "_6f-2";
export var rowHeader = "_6f-3";
export var table = "_6f-1";
export var tableContainer = "_6f-0";